import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  FormEmail as EmailField,
  FormTextField as TextField,
} from '@uncinc/uncinc-react-kitchen-sink';

export interface BuddiesFormFieldsProps {
  translationBase?: string;
}

const BuddiesFormFields: React.FC<BuddiesFormFieldsProps> = (props) => {
  const { translationBase } = props;

  const { t } = useTranslation();

  return (
    <>
      <TextField
        fieldName="name"
        title={t(`${translationBase}.fields.name.label`)}
        placeholder={t(`${translationBase}.fields.name.placeholder`)}
        description={t([`${translationBase}.fields.name.description`, ''])}
        descriptionAboveInput
      />

      <EmailField
        fieldName="email"
        title={t(`${translationBase}.fields.email.label`)}
        placeholder={t(`${translationBase}.fields.email.placeholder`)}
        description={t([`${translationBase}.fields.email.description`, ''])}
        descriptionAboveInput
      />
    </>
  );
};

export default BuddiesFormFields;
